import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SaasDtoKeysEnum } from '@zaoblako/shared/modules/saas/enums/saas-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { booleanSchema } from '@zaoblako/shared/modules/serde/schemas/boolean.schema';

import * as yup from 'yup';

/** Rate plan create/update form API request body */
export interface RatePlanFormInterface {
  name: string;
  description?: string;
  availableModules: string[];
  price: number;
  isDefault: boolean;
}

/** Rate plan create/update form API request body - DTO schema */
export const RatePlanFormDto = SerdeDtoClass.create<RatePlanFormInterface>(SaasDtoKeysEnum.RATE_PLAN_FORM_DTO, {
  name: {
    label: 'Имя',
    serializer: yup.string().required(DtoMessageEnum.REQUIRED_FIELD),
  },
  description: {
    optional: true,
    label: 'Описание',
    serializer: yup.string(),
  },
  availableModules: {
    label: 'Доступные модули',
    serializer: yup.array(yup.string()).required(DtoMessageEnum.EMPTY_ARRAY),
  },
  price: {
    label: 'Цена',
    serializer: yup.number()
      .min(0, DtoMessageEnum.NOT_POSITIVE)
      .integer(DtoMessageEnum.NOT_INTEGER)
      .required(DtoMessageEnum.REQUIRED_FIELD),
  },
  isDefault: {
    label: 'По умолчанию',
    serializer: booleanSchema,
  },
});
